<template>
    <div class="perMain">
         <a-avatar-group :max-count="3" :max-style="{ color: '#f56a00', backgroundColor: '#fde3cf', marginLeft: '0px',lineHeight: '28px', cursor: 'pointer' }">
            <div class="avatar" v-for="(item,index) in allList" :key="index">
                <div class="avatarrel">
                    <a-avatar style="line-height: 28px;" :src="item.url==null?'':item.url">
                        {{item.url==null||item.url==''?item.name.charAt(0):''}}
                    </a-avatar>
                    <close-circle-filled class="remove" @click="removeUser(item)"/>
                    <!-- 0 普通用户 1 vip 2 svip -->
                    <img class="ava-vipImg" v-if="item.vipType!=0" :src="require(item.vipType==1?'@/assets/Image/userInfo/vip.png':'@/assets/Image/userInfo/svip.png')" alt="">
                </div>
                <div class="name">
                    <!-- {{item.name}} -->
                    <text-ellipsis style="margin-left: 0px;"
                        :text="item.name"
                        :chinese-ratio="2"
                        :max-length="6"/>
                </div>
            </div>
        </a-avatar-group>
        <a-avatar class="addUser" @click="userVisible=true" :src="require('../../../assets/Image/popover/addUser.png')"></a-avatar>
        <selectUserSearch v-model:visible="userVisible" :value="selectValue" mode="multiple" @submitSelect="submitSelect"></selectUserSearch>
        <!-- <selectUser v-model:visible="userVisible" :value="selectValue" mode="multiple" @submitSelect="submitSelect"></selectUser> -->
    </div>
</template>
<script>
import selectUser from '@/components/selectUser'
import selectUserSearch from '@/components/selectUserSearch'
export default {
    components:{
        selectUser,selectUserSearch
    },
    props:{
        value:{
            type:Array,
            default:()=>[]
        }
    },
    model: {
      prop: 'value'
    },
    data() {
        return {
            allList: this.value,
            selectValue: this.value.map(item => {
                return item.userNO
            }),
            userVisible:false,
        }
    },
    methods:{
        //选中人员后事件
        submitSelect(value){
            this.allList = value.map(item => {
                return {
                    // userid:item.userid,
                    userNO:item.userNO,
                    name:item.name==''?'企业用户':item.name,
                    url:item.headPortrait
                }
            })
            this.userVisible = false
            // console.log(value)
            this.selectValue = value.map(item => {
                return item.userNO
            })
            console.log(this.selectValue)
        },
        //删除选中人员
        removeUser(item){
            this.allList.splice(this.allList.findIndex(a => a.userNO == item.userNO), 1)
            this.selectValue.splice(this.selectValue.findIndex(val => val == item.userNO), 1)
        }
    },
    watch: {
      allList(value) {
        // console.log('子组件下拉框值发生改变：', this.dialogVisible)
        // console.log(value)
        // console.log(this.allList)
        this.$emit('update:value', this.allList)
      },
      value(value){
        this.allList = value
      }
    }
}
</script>
<style lang="less">
.avatarrel{
    position: relative;
    display: inline-block;
    .remove{
        position: absolute;
        top: 0px;
        right: 0px;
        background-color: #ffffff;
        border-radius: 6px;
        color: #fa4f47;
        cursor: pointer;
        font-size: 12px;
        display: none;
    }
    &:hover .remove{
        display: block;
    }
}
.addUser{
    margin-left: 8px !important;
    cursor: pointer;
    &:hover{
        box-shadow: 0px 1px 8px 0.9px rgba(216, 216, 216, 0.6); 
    }
}
.avatar{
    display: inline-block;
    text-align: center;
    margin-right: 8px;
}
.name{
    font-size: 12px;
    color: #7b7b7b;
    margin-top: 3px;
    margin-bottom: 10px;
}
/deep/ .ant-avatar-group .ant-avatar:not(:first-child){
    margin-left: 8px;
}
.ava-vipImg {
    position: absolute;
    bottom: -8px; /* 进一步增加距离 */
    left: 50%;
    transform: translateX(-50%);
    width: 38px; /* 更宽一些 */
    height: 19px; /* 高度相对较小，形成胶囊形状 */
    border-radius: 5px;
    object-fit: contain;
    z-index: 1;
}
// /deep/ .ant-avatar-string{
//     line-height: 28px !important;
// }
</style>